import { CSSProperties, ReactNode } from "react";
import { motion } from "framer-motion";
import { useActivityOffset } from "@/hooks/useActivityOffset";

interface MobileLayoutProps {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  noAnimation?: boolean;
  style?: CSSProperties;
}

const MobileLayout = ({ children, className = "", noPadding = false, noAnimation = false, style }: MobileLayoutProps) => {
  const Wrapper = noAnimation ? "div" : motion.div;
  const animProps = noAnimation ? {} : {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.3 },
  };
  const offset = useActivityOffset();
  const safeAreaTop = "max(2rem, env(safe-area-inset-top, 2rem))";
  const paddingTopValue = offset > 0
    ? `calc(${safeAreaTop} + ${offset}px + 2rem)`
    : safeAreaTop;

  const mergedStyle: CSSProperties = {
    paddingTop: paddingTopValue,
    ...(style || {}),
  };

  return (
    <Wrapper
      {...animProps}
      style={mergedStyle}
      className={`min-h-screen-safe max-w-md mx-auto flex flex-col bg-background ambient-noise ${noPadding ? "" : "px-5"} ${className}`}
    >
      {children}
    </Wrapper>
  );
};

export default MobileLayout;
